import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { KnowledgeSource } from '@vendasta/embeddings';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { KnowledgeSourceConfigWebsiteScrapeConfigScrapedPage } from '@vendasta/embeddings/lib/_internal/objects/knowledge-base';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { AiKnowledgeService } from '@galaxy/ai-knowledge';

@Component({
  selector: 'ai-knowledge-web-pages-dialog',
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    GalaxyFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatButton,
    MatDialogClose,
    TranslateModule,
  ],
  templateUrl: './knowledge-web-pages-dialog.component.html',
  styleUrl: './knowledge-web-pages-dialog.component.scss',
})
export class KnowledgeWebPagesDialogComponent {
  private dialogRef = inject(MatDialogRef<KnowledgeWebPagesDialogComponent>);
  protected readonly knowledgeSource: KnowledgeSource = inject(MAT_DIALOG_DATA).knowledgeSource;
  private readonly knowledgeService = inject(AiKnowledgeService);

  protected sortedWebPages: KnowledgeSourceConfigWebsiteScrapeConfigScrapedPage[] =
    this.knowledgeSource.config.websiteScrapeConfig.scrapedPages.sort((a, b) => a.title.localeCompare(b.title));
  protected form: FormGroup = new FormGroup({
    pages: new FormArray(this.sortedWebPages.map((page) => new FormControl(page.trainingEnabled))),
  });

  get pageControls() {
    return this.form.get('pages') as FormArray<FormControl>;
  }

  async train() {
    this.pageControls.value.forEach((value, index) => {
      this.sortedWebPages[index].trainingEnabled = value;
    });

    await this.knowledgeService.updateKnowledgeSourceNameAndConfig(this.knowledgeSource);
    this.dialogRef.close({
      refresh: true,
    });
  }
}
